import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "mt-2 fw-bold" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "text-center mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sunbed = _resolveComponent("icon-sunbed")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_icon_sunbed)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Le tue vacanze AuraClub",
          text: "Le tue vacanze AuraClub"
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Scegli dove trascorrere le tue settimane di vacanza come socio AuraClub",
          text: "Scegli dove trascorrere le tue settimane di vacanza come socio AuraClub"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_localized_text, {
          localizedKey: "Utilizzate",
          text: "Utilizzate"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.usedVouchers.length) + " / " + _toDisplayString(_ctx.vouchers.length), 1)
      ])
    ]),
    (_ctx.$route.fullPath != '/network/vacations')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "btn btn-primary",
              to: "/network/vacations"
            }, {
              default: _withCtx(() => [
                (_ctx.usedVouchers.length < _ctx.vouchers.length)
                  ? (_openBlock(), _createBlock(_component_localized_text, {
                      key: 0,
                      localizedKey: "Prenota ora",
                      text: "Prenota ora"
                    }))
                  : (_openBlock(), _createBlock(_component_localized_text, {
                      key: 1,
                      localizedKey: "Visualizza",
                      text: "Visualizza"
                    }))
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}